import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/appointment.css';

// Brochure paths
const brochurePdfPath = require('../assets/img/sleep-brochure.pdf');
const brochureCoverImg = require('../assets/img/sleep-brochure-cover.png');

class CoursesComponent extends Component {
    openBrochureInNewTab = () => {
        window.open(brochurePdfPath, '_blank');
    };

    render() {
        return (
            <section className="section-padding" style={{ background: '#f8f9fa' }}>
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left Side - Course Content */}
                        <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">
                            <div className="pr-lg-4">
                                <h2>Sleep Technologist Certification Course</h2>
                                <p className="lead mb-3">
                                    Begin your journey into the science of sleep and its impact on overall wellbeing.
                                </p>
                                <p className="mb-4">
                                    This certification course equips learners with foundational knowledge and essential
                                    practical skills required to support sleep diagnostics and therapeutic care. Designed
                                    for aspiring sleep technologists and wellness professionals, the program offers a
                                    structured introduction to sleep disorders, diagnostic procedures, and the role of
                                    sleep technology in modern healthcare.
                                </p>
                                <Link to="/contact" className="theme-btn btn_black">
                                    Enroll Now
                                </Link>
                            </div>
                        </div>

                        {/* Right Side - Brochure Image */}
                        <div className="col-lg-5 col-md-12">
                            <div
                                className="brochure-box"
                                style={{
                                    position: 'relative',
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                    overflow: 'hidden',
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                                }}
                                onClick={this.openBrochureInNewTab}
                            >
                                <img
                                    src={brochureCoverImg}
                                    alt="Sleep Technologist Certification Course Brochure"
                                    className="img-fluid"
                                    style={{ display: 'block', width: '100%' }}
                                />
                                <div
                                    className="brochure-overlay d-flex align-items-center justify-content-center"
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'rgba(0,0,0,0.6)',
                                        opacity: 0,
                                        transition: 'opacity 0.3s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = 0}
                                >
                                    <span
                                        className="theme-btn"
                                        style={{ padding: '8px 15px', fontSize: '14px' ,height:'auto',lineHeight:'normal'}}
                                    >
                                        Download Brochure
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default CoursesComponent;
